/**
 * Browser and OS detection utilities
 */

export const isIOS = (): boolean => {
    if (typeof window === 'undefined') return false;
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const isAndroid = (): boolean => {
    if (typeof window === 'undefined') return false;
    return /Android/.test(navigator.userAgent);
};

export const isMobile = (): boolean => {
    return isIOS() || isAndroid();
};

export const isSafari = (): boolean => {
    if (typeof window === 'undefined') return false;
    const ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome/.test(ua);
};

export const isChrome = (): boolean => {
    if (typeof window === 'undefined') return false;
    return /Chrome/.test(navigator.userAgent);
};

export const isStandalone = (): boolean => {
    if (typeof window === 'undefined') return false;
    return (window.matchMedia('(display-mode: standalone)').matches) ||
        ((navigator as any).standalone) ||
        document.referrer.includes('android-app://');
};

export const getBrowserDescription = (): string => {
    if (isIOS()) return 'iOS Safari';
    if (isAndroid()) return 'Android Chrome';
    if (isChrome()) return 'Chrome';
    if (isSafari()) return 'Safari';
    return 'Browser';
};
